// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ql-view-setup__form {
  width: 480px;
  border: 1px solid var(--g-color-line-generic);
  border-radius: 8px;
  margin: 20px;
  padding: 20px;
}
.ql-view-setup__form-header {
  font-size: 17px;
  margin-bottom: 20px;
  display: inline-block;
}
.ql-view-setup__form-row {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}
.ql-view-setup__form-input {
  width: 330px;
}
.ql-view-setup__form-label {
  width: 90px;
  margin-right: 20px;
  display: inline-block;
}
.ql-view-setup__connection-select-btn {
  display: inline-block;
}
.ql-view-setup__connection-select-btn-content {
  display: flex;
}
.ql-view-setup__connection-select-btn-wrapper {
  display: inline-block;
  max-width: 240px;
}
.ql-view-setup__connection-select-btn-wrapper_error {
  width: 250px;
}
.ql-view-setup__form-buttons {
  margin-top: 32px;
}
.ql-view-setup__entry-icon {
  margin-right: 7px;
  height: 28px;
}`, "",{"version":3,"sources":["webpack://./src/ui/units/ql/containers/QL/ViewSetup/ViewSetup.scss"],"names":[],"mappings":"AACI;EACI,YAAA;EACA,6CAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;AAAR;AAGI;EACI,eAAA;EACA,mBAAA;EACA,qBAAA;AADR;AAII;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;AAFR;AAKI;EACI,YAAA;AAHR;AAMI;EACI,WAAA;EACA,kBAAA;EACA,qBAAA;AAJR;AAOI;EACI,qBAAA;AALR;AAQI;EACI,aAAA;AANR;AASI;EACI,qBAAA;EACA,gBAAA;AAPR;AAQQ;EACI,YAAA;AANZ;AAUI;EACI,gBAAA;AARR;AAWI;EACI,iBAAA;EAEA,YAAA;AAVR","sourcesContent":[".ql-view-setup__form {\n  width: 480px;\n  border: 1px solid var(--g-color-line-generic);\n  border-radius: 8px;\n  margin: 20px;\n  padding: 20px;\n}\n.ql-view-setup__form-header {\n  font-size: 17px;\n  margin-bottom: 20px;\n  display: inline-block;\n}\n.ql-view-setup__form-row {\n  display: flex;\n  align-items: center;\n  margin-bottom: 12px;\n}\n.ql-view-setup__form-input {\n  width: 330px;\n}\n.ql-view-setup__form-label {\n  width: 90px;\n  margin-right: 20px;\n  display: inline-block;\n}\n.ql-view-setup__connection-select-btn {\n  display: inline-block;\n}\n.ql-view-setup__connection-select-btn-content {\n  display: flex;\n}\n.ql-view-setup__connection-select-btn-wrapper {\n  display: inline-block;\n  max-width: 240px;\n}\n.ql-view-setup__connection-select-btn-wrapper_error {\n  width: 250px;\n}\n.ql-view-setup__form-buttons {\n  margin-top: 32px;\n}\n.ql-view-setup__entry-icon {\n  margin-right: 7px;\n  height: 28px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
